import type { ComboboxRootProps } from '@chakra-ui/react';

export interface ComboboxItemProps {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface ComboboxProps
  extends Omit<ComboboxRootProps<ComboboxItemProps>, 'onChange' | 'onValueChange' | 'collection'> {
  orientation?: 'vertical' | 'horizontal';
  label?: string;
  labelWidth?: string;
  hint?: string;
  error?: string;
  disabled?: boolean;
  invalid?: boolean;
  readOnly?: boolean;
  required?: boolean;
  items?: Array<ComboboxItemProps>;
  value?: Array<string>;
  defaultValue?: Array<string>;
  placeholder?: string;
  multiple?: boolean;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'outline' | 'subtle';
  /** Callback when value changes. event.target.value is JSON-stringified array. */
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  /**
   * Called with the raw typed text on every input change. Enables async
   * (server-filtered) search — pair with `shouldFilter={false}`.
   */
  onInputChange?: (inputValue: string) => void;
  /**
   * When false, skip the built-in substring filter and render `items` as
   * given — for async search where the server already filtered. Default true.
   */
  shouldFilter?: boolean;
  /** Show a spinner in the indicator group (async search in flight). */
  loading?: boolean;
  /** Custom option content; defaults to the item label. */
  renderItem?: (item: ComboboxItemProps) => React.ReactNode;
}

export const ComboboxDefaultProps: ComboboxProps = {
  orientation: 'vertical',
  label: '',
  hint: '',
  error: '',
  disabled: false,
  invalid: false,
  readOnly: false,
  required: false,
  multiple: false,
  size: 'md',
  variant: 'outline',
};
